<template>
  <div class="sidebar-container">
    <v-list class="overflow-y-auto">
      <v-list-group
      v-for="item in items"
      :key="item.title"
      v-model="item.active"
      action
      link
      :prepend-icon="item.action"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <router-link
            v-text="item.title"
            class="text-decoration-none"
            router
            :to="item.link"
          ></router-link>
        </v-list-item-content>
      </template>
      <v-list-item-group>
        <v-list-item v-for="child in item.items" :key="child.title" link>
          <v-list-item-content>
            <router-link
              v-text="child.title"
              class="text-decoration-none"
              router
              :to="child.childLink"
            ></router-link>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        action: "mdi-view-dashboard",
        title: "Dashboard",
        link: "/",
        active: false,
      },
      {
        action: "mdi mdi-credit-card-outline",
        title: "Transactions",
        link: "",
        active: false,
        items: [
          { title: "Trx. History", childLink: "/transaction-history" },
          { title: "Transfer Balance", childLink: "/transfer-form" },
          // { title: "Withdraw Balance", childLink: "/bank-transfer" },
          // { title: "Transfer To Crypto", childLink: "/transfer-to-crypto" },
          { title: "Withdraw Balance", childLink: "/ib-commission-withdraw" },
        ],
      },
      {
        action: "mdi-account-outline",
        title: "View Profile",
        link: "/profile-view",
        active: false,
      },
      {
        action: "mdi mdi-chart-arc",
        title: "Commission",
        link: "/commission-statistics",
        active: false,
      },
      {
        action: "mdi mdi-account-multiple-outline",
        title: "Clients",
        link: "",
        active: false,
        items: [
          { title: "Trading Acc. Summary", childLink: "/all-trading-accounts" },
          { title: "Clients Acc. Summary", childLink: "/client-acc-summary" },
          { title: "Clients Tree & Earning", childLink: "/client-tree" },
          { title: "Transactions", childLink: "/client-transaction-history" },
          { title: "Trading History", childLink: "/trading-history" },
        ],
        
      },
      {
        action: "mdi mdi-quadcopter",
        title: "Drone View",
        link: "/drone-view",
        active: false,
      },
      {
        action: "mdi mdi-account-star-outline",
        title: "Trade Master",
        link: "/trade-master",
      },
      {
        action: "mdi mdi-television",
        title: "Marketing Tools",
        link: "/marketing-tools?banner-type=static",
        active: false,
      },
      {
        action: "mdi mdi-television",
        title: "Terms And Conditions",
        link: "/terms-and-condition",
        active: false,
      },
      {
        action: "mdi-clock-time-twelve-outline",
        title: "FAQ",
        link: "/faq",
        active: false,
      },
    ],
  }),

  mounted() {
    this.setActiveMenu();
  },

  watch: {
    "$route.path": "setActiveMenu",
  },

  methods: {
    setActiveMenu() {
      const currentPath = this.$route.path;
      this.items.forEach((item) => {
        if (item.items) {
          item.active = item.items.some((child) => child.childLink === currentPath);
        } else {
          item.active = item.link === currentPath;
        }
      });
    },
  },
};
</script>

<style scoped>
  .sidebar-container {
    height: calc(100vh - 120px);
  }

  .v-list-item__content_main {
    width: 600px !important;
  }
</style>
